<template>
  <div class="contract_info_area" id="contract_info">
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="corporationNameLabel"
        :valueLabel="corporation.corporationName"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="corporationAddressLabel"
        :valueLabel="corporation.corporationAddress"
      ></valueLabelSection>

      <valueLabelSection
        :titleLabel="corporationUserDepartmentsLabel"
        :valueLabel="corporation.corporationUserDepartments"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="corporationUserPositionLabel"
        :valueLabel="corporation.corporationUserPosition"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="corporationUserNameLabel"
        :valueLabel="corporation.corporationUserName"
      ></valueLabelSection>
    </div>
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="corporationUserTelephoneNumberLabel"
        :valueLabel="corporation.corporationUserTelephoneNumber"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="corporationUserMailAddressLabel"
        :valueLabel="corporation.corporationUserMailAddress"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="contractDateLabel"
        :valueLabel="corporation.contractDate"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="availableDeviceCountsLabel"
        :valueLabel="availableDeviceCounts"
      ></valueLabelSection>
    </div>
  </div>
</template>

<script>
import valueLabelSection from './valueLabelSection.vue'

export default {
  props: {
    contentHeight: String
  },
  data() {
    return {
      corporationNameLabel: '法人名',
      corporationAddressLabel: '法人住所',
      contractDateLabel: '契約日',
      corporationUserDepartmentsLabel: '法人担当者（部署）',
      corporationUserPositionLabel: '法人担当者（役職）',
      corporationUserNameLabel: '法人担当者（氏名）',
      corporationUserTelephoneNumberLabel: '法人担当者連絡先（電話）',
      corporationUserMailAddressLabel: '法人担当者連絡先（メール）',
      availableDeviceCountsLabel: '契約台数'
    }
  },
  computed: {
    corporation() {
      return this.$store.state.corporations.corporation
    },
    availableDeviceCounts() {
      var counts = this.$store.state.corporations.corporation
        .availableDeviceCounts
      return counts + '台'
    }
  },
  components: {
    valueLabelSection
  }
}
</script>

<style scoped>
.detail_content {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/contractInfo.vue